import { ensureAudio } from "../audio/sfx";
import type { GameAction } from "../core/types";
import { attachKeyboard } from "./keyboard";
import { GamepadMonitor } from "./gamepad";

export interface InputManager {
  /** Her karede çağrılır; gamepad durumunu tarar. */
  poll: (now: number) => void;
  /** Dinleyicileri kaldırır. */
  dispose: () => void;
}

/** Klavye + gamepad girişlerini tek `GameAction` akışında birleştirir. */
export function createInputManager(dispatch: (action: GameAction) => void): InputManager {
  const dispatchWithAudio = (action: GameAction) => {
    ensureAudio();
    dispatch(action);
  };

  const detachKeyboard = attachKeyboard(dispatchWithAudio);
  const monitor = new GamepadMonitor(dispatchWithAudio);

  return {
    poll: (now) => monitor.poll(now),
    dispose: () => detachKeyboard(),
  };
}
